import React from 'react';
import { data } from '../../constants';
import './Services.scss';


// this is child component - Use by Services Parent Component
const ServiceBox = ({ service: { number, icon, title, text } }) => (
    <div className="box">
        <span>{number}</span>
        <i className={`fas fa-${icon}`}></i>
        <h3>{title}</h3>
        <p>{text}</p>
    </div>
);


const Services = () => {
    return (
        <section className="services" id="services">

            <h1 className="heading">
                our <span>services</span>
            </h1>

            <div className="box-container">
                {
                    data.services.map(service =>
                        <ServiceBox key={service.number} service={service} />
                    )
                }
            </div>

        </section>
    );
}

export default Services;